import {combineReducers} from 'redux';
import currentUser, {getCurrentUser} from './spotifyUser';
import playlist from './spotifyPlaylist';

export {getCurrentUser};

const rootReducer = combineReducers({
  currentUser,
  playlist
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js